import { EmptyState, PageHeader } from '@portals-platform/ui';
import { RefreshCwIcon } from 'lucide-react';
import { PortalShell } from '../components/portal-shell.js';

export function RenewalsPage() {
  return (
    <PortalShell activeId="renewals" pageTitle="Renewals">
      <div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
        <PageHeader
          title="Renewals"
          description="Track and manage upcoming certificate renewals."
        />
        <EmptyState
          icon={<RefreshCwIcon />}
          title="Renewals dashboard coming soon"
          description="Upcoming renewals, expiry timelines, and renewal workflows will appear here."
        />
      </div>
    </PortalShell>
  );
}
